import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbb609d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-light" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-brand" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent",
  style: {display: 'block'}
}
const _hoisted_8 = {
  class: "navbar-nav me-auto mb-2 mb-lg-0 center",
  id: "header"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "IDP Studio", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "IDP Engine", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "IDP LM", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "http://imcgpt.baihai.co:9997/information",
  target: "_blank"
}, "IMC GPT", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "白海简介", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "加入我们", -1))
const _hoisted_15 = { class: "navbar-nav mb-2 mb-lg-0" }
const _hoisted_16 = { class: "btn-warp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MobileDropdownItem = _resolveComponent("MobileDropdownItem")!
  const _component_DropdownItem = _resolveComponent("DropdownItem")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "navbar-toggler",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mobilToogleOpen && _ctx.mobilToogleOpen(...args)), ["prevent"])),
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, _hoisted_6),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                _createVNode(_component_MobileDropdownItem, {
                  class: _normalizeClass(_ctx.active === 0? ' active' : '')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "nav-link",
                      "aria-current": "page"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("首页")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_MobileDropdownItem, { class: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Dropdown, {
                      name: 'AI平台',
                      isOpen: false,
                      class: _normalizeClass(_ctx.active === 1? 'active' : '')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DropdownItem, { to: "/studio" }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DropdownItem, { to: "/engine" }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DropdownItem, { to: "/aigc" }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DropdownItem, { style: {"display":"none"} }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_MobileDropdownItem, {
                  class: _normalizeClass(_ctx.active === 8? 'active' : '')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/gallery",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("AI 市场")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_MobileDropdownItem, {
                  class: _normalizeClass(_ctx.active === 7? ' active' : '')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/gpucalc",
                      class: "nav-link",
                      "aria-current": "page"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("GPU计算")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_MobileDropdownItem, {
                  class: _normalizeClass(_ctx.active === 3? 'active' : '')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/customerstories",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("客户案例")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_MobileDropdownItem, {
                  class: _normalizeClass(_ctx.active === 4? 'active' : '')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/unite",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("合作伙伴")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_MobileDropdownItem, { class: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Dropdown, {
                      name: '社区',
                      isOpen: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DropdownItem, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkWorld('https://github.com/BaihaiAI/IDP')))
                            }, "开源社区")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DropdownItem, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linkGo('https://www.zhihu.com/column/c_1465275278654500864')))
                            }, "博客")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_MobileDropdownItem, { class: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Dropdown, {
                      name: '关于我们',
                      isOpen: false,
                      class: _normalizeClass(_ctx.active === 1? 'active' : '')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DropdownItem, { to: "/introduce" }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DropdownItem, { to: "/recruit" }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linkGo('https://idp.baihai.co/login')))
                  }, "登 录"),
                  _createTextVNode("   "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    onClick: _cache[4] || (_cache[4] = () => _ctx.linkGo('https://idp.baihai.co/register'))
                  }, "注 册")
                ])
              ])
            ], 512), [
              [_vShow, _ctx.mobileIsOpen]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}